module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-mobile-411x93.a79e4db4.jpg";